import api from './api';

export const produkHukumPublicService = {
    getProdukHukum: async (params = {}) => {
        try {
            const response = await api.get('/produk-hukum', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    getByKategori: async (kategori) => {
        try {
            const response = await api.get(`/produk-hukum/kategori/${kategori}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },
};